/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINDIVIDUALWITHHOLDINGTAXREASON = {
    AnyPersonInsofarAsTheDividendConstitutesIncomeOfThatPersonIeFallsIntoNormalTaxSystemDividendReasonL: 'L',
    DoubleTaxAgreementInterestReasonH: 'H',
    DualListedEquityDividendReasonJ: 'J',
    DoubleTaxationAgreementDividendReasonY: 'Y'
} as const;
export type IAPINDIVIDUALWITHHOLDINGTAXREASON = typeof IAPINDIVIDUALWITHHOLDINGTAXREASON[keyof typeof IAPINDIVIDUALWITHHOLDINGTAXREASON];


export function IAPINDIVIDUALWITHHOLDINGTAXREASONFromJSON(json: any): IAPINDIVIDUALWITHHOLDINGTAXREASON {
    return IAPINDIVIDUALWITHHOLDINGTAXREASONFromJSONTyped(json, false);
}

export function IAPINDIVIDUALWITHHOLDINGTAXREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINDIVIDUALWITHHOLDINGTAXREASON {
    return json as IAPINDIVIDUALWITHHOLDINGTAXREASON;
}

export function IAPINDIVIDUALWITHHOLDINGTAXREASONToJSON(value?: IAPINDIVIDUALWITHHOLDINGTAXREASON | null): any {
    return value as any;
}

